import React from 'react'
import { Link } from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha'

import utils from '../utils'
import authentication from '../http/auth'
import LoadingText from '../components/LoadingText'

class DefaultRegistrationForm extends React.Component {
  state = {
    fields: null,
    isCaptchaValidated: false,
  };

  componentDidMount() {
    if (this.state.fields !== null) {
      return
    }

    var defaultFields = [
      {
        label: 'Username',
        name: 'username',
        placeholder: 'Username',
        required: true,
        type: 'text',
      },
      {
        label: 'Password',
        name: 'password',
        placeholder: 'Password',
        required: true,
        type: 'password',
      },
      {
        label: 'Confirm password',
        name: 'passwordConfirmation',
        placeholder: 'Confirm password',
        required: true,
        type: 'password',
      },
      {
        label: 'Keys',
        name: 'keys',
        placeholder: '{"torrent9":"xxx", "yggtorrent":"xxx"}',
        required: true,
        type: 'text',
      },
    ]

    this.setState({
      fields: defaultFields,
    })
  }

  verifyCallback(response) {
    authentication.validateRecaptcha(response, (isValid) => {
      if (isValid)
      {
        this.setState({
          isCaptchaValidated: true,
        })
      }
      else
      {
        this.setState({
          isCaptchaValidated: false,
        })
      }
    })
  }

  expiredCallback() {
    this.setState({
      isCaptchaValidated: false,
    })
  }

  render() {
    var fieldMarkup = null

    if (this.state.fields !== null) {
      fieldMarkup = []

      this.state.fields.forEach((field, index) => {
        var fieldId = `sp-${field.name}-${index}`
        fieldMarkup.push(
          <div key={ fieldId } className="form-group">
            <label htmlFor={ fieldId } className="col-xs-12 col-sm-4 control-label">{ field.label }</label>
            <div className="col-xs-12 col-sm-4">
              <input type={ field.type } className="form-control" id={ fieldId } name={ field.name } placeholder={ field.placeholder } required={ field.required } />
            </div>
          </div>
        )
      })

      fieldMarkup.push(
        <div key="captcha-wrapper" className="form-group">
          <div className="col-sm-offset-4 col-sm-4">
            <ReCAPTCHA
              sitekey='6LeQ1REUAAAAANVv2RCf5rFTOApvpBaiUgoGiwm0'
              onChange={this.verifyCallback.bind(this)}
              onExpired={this.expiredCallback.bind(this)}
              hl="fr"
            />
          </div>
        </div>
      )

      fieldMarkup.push(
        <div key="register-button" className="form-group">
          <div className="col-sm-offset-4 col-sm-4">
            <p className="alert alert-danger" data-spIf="form.error"><span data-spBind="form.errorMessage" /></p>
            { this.state.isCaptchaValidated ?
              <button type="submit" className="btn btn-primary" disabled={this.state.isCaptchaValidated}>S'inscrire</button> :
              <p className="text-info">Veuillez valider le captcha ci-dessus.</p>
            }
          </div>
        </div>
      )
    }

    return (
      <div>
        <RegistrationForm {...this.props}>
          <div className='sp-login-form'>
            <div className="row" data-spIf="account.created">
              <div className="col-sm-offset-4 col-xs-12 col-sm-4">
                <p className="alert alert-success">
                  Your account has been created. <Link to='/'>Continue</Link>.
                </p>
              </div>
            </div>
            <div className="row" data-spIf="!account.created">
              <div className="col-xs-12">
                <div className="form-horizontal">
                  { fieldMarkup ? fieldMarkup : <LoadingText /> }
                </div>
              </div>
            </div>
          </div>
        </RegistrationForm>
      </div>
    )
  }
}

export default class RegistrationForm extends React.Component {

  state = {
    fields: {
      email: '',
      password: '',
      passwordConfirmation: '',
      keys: '',
    },
    errorMessage: null,
    isFormProcessing: false,
    isAccountCreated: false,
  };

  onFormSubmit(e) {
    e.preventDefault()

    let onSubmitSuccess = this.props.onSubmitSuccess
    let onSubmitError = this.props.onSubmitError

    let setErrorState = (recentError, newError) => {
      this.setState({
        isFormProcessing: false,
        errorMessage: (newError || recentError).message,
      })
    }

    let next = (err, data) => {
      if (err) {
        if (onSubmitError) {
          return onSubmitError({
            data: data,
            error: err,
          }, setErrorState.bind(this, err))
        }

        return setErrorState(err)
      }

      // If the user didn't specify any data,
      // then simply default to what we have in state.
      data = data || this.state.fields

      authentication.register(data.username, data.password, data.passwordConfirmation, data.keys, (registered) => {
        if (!registered)
        {
          let err = {'message': 'Registration failed'}
          if (onSubmitError) {
            return onSubmitError({
              data: data,
              error: err,
            }, setErrorState.bind(this, err))
          }
          return setErrorState(err)
        }
        else
        {
          let setSuccessState = () => {
            this.setState({
              isFormProcessing: false,
              isAccountCreated: true,
            })
          }

          if (onSubmitSuccess) {
            return onSubmitSuccess({
              data: data,
              result: {'message': 'Registration succedeed'},
            }, setSuccessState)
          }

          setSuccessState()
        }
      })
    }

    this.setState({
      isFormProcessing: true,
    })

    if (this.props.onSubmit) {
      e.data = this.state.fields
      this.props.onSubmit(e, next)
    } else {
      next(null, this.state.fields)
    }
  }

  _mapFormFieldHandler(element, tryMapField) {
    let tryMapFormField = (name) => {
      if (name.indexOf('customData.') === 0) {
        tryMapField(name)
        return
      }

      switch(name) {
        case 'login':
        case 'username':
          tryMapField('username')
          break
        case 'password':
          tryMapField('password')
          break
        case 'passwordConfirmation':
          tryMapField('passwordConfirmation')
          break
        case 'keys':
          tryMapField('keys')
          break
        default:
          break
      }
    }

    if (typeof element.type === 'function' && utils.containsWord(element.type.name, ['input', 'field', 'text'])) {
      if (element.props && element.props.name) {
        tryMapFormField(element.props.name)
      }
    } else if (['input', 'textarea'].indexOf(element.type) > -1) {
      if (element.props.type !== 'submit') {
        tryMapFormField(element.props.name)
      }
    }
  }

  _spIfHandler(action, element) {
    var test = null

    switch (action) {
      case 'form.processing':
        test = this.state.isFormProcessing
        break
      case 'form.error':
        test = !!this.state.errorMessage
        break
      case 'account.created':
        test = this.state.isAccountCreated
        break
      default:
        break
    }

    return test
  }

  _spBindHandler(bind, element) {
    var result = false

    switch (bind) {
      case 'form.errorMessage':
        var className = element.props ? element.props.className : undefined
        result = <span className={className}>{this.state.errorMessage}</span>
        break
      default:
        break
    }

    return result
  }

  render() {
    if (this.props.children) {
      var selectedProps = utils.excludeProps(['redirectTo', 'hideSocial', 'onSubmit', 'onSubmitError', 'onSubmitSuccess', 'children'], this.props)

      return (
        <form onSubmit={this.onFormSubmit.bind(this)} {...selectedProps}>
          {utils.makeForm(this, this._mapFormFieldHandler.bind(this), this._spIfHandler.bind(this), this._spBindHandler.bind(this))}
        </form>
      )
    } else {
      return <DefaultRegistrationForm {...this.props} />
    }
  }
}
